import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ITooltipPosition } from '../../interfaces/ITooltipPosition';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TooltipComponent implements OnInit, AfterViewInit {

  @Input() public template: TemplateRef<any>;

  @Input() public data: any; // data to inject into template's context. If array => must be wrapped in object

  @Input() public customClasses: string;
  @Input() public width: number = 290; //px
  @Input() public position: ITooltipPosition;
  @Input() public staticPosition: 'bottom' | 'right';

  @ViewChild('tooltipText') tooltipText;

  private calculatedPosition: 'bottom' | 'right' = 'bottom';

  constructor(private el: ElementRef) { }
  ngAfterViewInit(): void {
    if(!this.staticPosition) {
      this.positionTooltip();
    }
    else {
      this.calculatedPosition = this.staticPosition;
      this.addStylesToCalculatedPosition();
    }
  }

  ngOnInit(): void {
  }

  private positionTooltip(): void {
    //Need to be refactored
    // const leftBorderOffset = this.el.nativeElement.getBoundingClientRect().left;
    // if(leftBorderOffset < this.width)
    //   this.calculatedPosition = 'right';

    //Temp solution.
    this.calculatedPosition = 'right';
    
    this.addStylesToCalculatedPosition();
  }

  private addStylesToCalculatedPosition(): void {
    if(this.position) {
      const el =  this.tooltipText.nativeElement;
      el.classList.add(this.calculatedPosition);
      el.style.setProperty('--top', this.position[this.calculatedPosition]?.y);
      el.style.setProperty('--left', this.position[this.calculatedPosition]?.x);
    }
  }

}
